import {FormattedMessage} from "react-intl";
import RenderCommission from "../../../cmp/RenderCommission";
import React from "react";

function RenderDiscountValue({coupon}) {
    return <span className="ml-2 badge badge-secondary">
                <FormattedMessage id={coupon.discount_type === "free_shipping" ? "Free shipping" : "coupon_code_discount"}
                                  defaultMessage={'{discount_value} off'} values={
                    {
                        discount_value: <RenderCommission commission_value={coupon.discount_value || coupon.discount_amount}
                                                          commission_type={coupon.discount_type}
                        />
                    }
                }
                />
        </span>
}

export default RenderDiscountValue;
